import React from 'react';

const Fotter = () => {
    return (
        <div style={{padding:"50px",marginTop:"50px"}}>
            <p className='text-center text-white'>&copy;copyright all right reserved shariar</p>
        </div>
    );
};

export default Fotter;